import React from 'react';
import { Formik } from 'formik';
import { Container, Col, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import validationSchema from '../form/SiteCreatorForm.schema';
import SiteCreatorForm from '../form/SiteCreatorForm';
import PageBreadcrumb from '../../common/components/layout/PageBreadcrumb';
import { createSite } from '../SiteCreatorActions';

const initialValues = {
  title: '',
  link: '',
  isActive: false,
  content: '',
};

function CreateSitePage() {
  const dispatch = useDispatch();

  const handleSubmit = (values, form) => {
    dispatch(createSite(values, form)).catch(() => form.setSubmitting(false));
  };

  const breadcrumbs = [
    { id: 1, type: 'home' },
    { id: 2, type: 'link', text: 'Site Creator', url: '/site-creators' },
    { id: 3, type: 'span', text: 'Add Site' },
  ];

  return (
    <Container fluid>
      <Row>
        <PageBreadcrumb items={breadcrumbs} pageTitle="Site Creator" />
        <Col md="12">
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            validateOnBlur
          >
            {() => <SiteCreatorForm title="Create a New Site" />}
          </Formik>
        </Col>
      </Row>
    </Container>
  );
}

export default CreateSitePage;
